import { MotionConfig, motion } from "framer-motion";
import { Check } from "lucide-react";
import Button from "~/design/ui/Button";
import StatusScreen, { StatusIcon } from "./StatusScreen";

// The check pops in, then a soft ring expands once: the payment went through.
// Server and client render the same tree (useReducedMotion is null on the server, so branching on it broke hydration):
// MotionConfig drops the transforms for reduced motion and CSS hides the ring.
function SuccessIcon() {
  return (
    <MotionConfig reducedMotion="user">
      <span className="relative grid place-items-center">
        <motion.span
          className="absolute inset-0 rounded-full bg-success-soft motion-reduce:hidden"
          initial={{ scale: 0.6, opacity: 1 }}
          animate={{ scale: 1.9, opacity: 0 }}
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1], delay: 0.3 }}
          aria-hidden
        />
        <motion.span
          initial={{ scale: 0.4, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: "spring", stiffness: 260, damping: 18 }}
        >
          <StatusIcon tone="success">
            <motion.span
              className="grid place-items-center"
              initial={{ scale: 0, rotate: -45 }}
              animate={{ scale: 1, rotate: 0 }}
              transition={{ type: "spring", stiffness: 420, damping: 15, delay: 0.18 }}
            >
              <Check strokeWidth={2.5} aria-hidden />
            </motion.span>
          </StatusIcon>
        </motion.span>
      </span>
    </MotionConfig>
  );
}

function MessageCardSuccess(props) {
  return (
    <StatusScreen
      icon={<SuccessIcon />}
      title={props.title}
      description={props.description}
      action={
        props.toDoHref && (
          <Button href={props.toDoHref} size="lg" block>
            {props.toDo}
          </Button>
        )
      }
    >
      {props.children}
    </StatusScreen>
  );
}

export default MessageCardSuccess;
